import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";

const InnerNavigationTab = ({
    type,
    activeMenu,
    items,
    onTabChange,
    cssClasses,
    scrollSpy = false, 
    scrollSpace,
}) => {
    const [activeTab, setTab] = useState(activeMenu || items[0]?.key);
    const containerRef = useRef(null);

    useEffect(() => {
        if (!scrollSpy && type === "tab") {
            setTimeout(() => {
                scrollToActiveElement();
            }, 500);
        }
    }, [activeTab]);

    useEffect(() => {
        const onScroll = () => {
            if (scrollSpy && scrollSpyRef.current) {
                handleScrollSpy();
            }
        };
    
        if (type === "tab" && scrollSpy) {
            window.addEventListener("scroll", onScroll);
            return () => window.removeEventListener("scroll", onScroll);
        }
    }, [scrollSpy, type, items, activeTab]);


   /*  For Horizontal scrolling in mobile or small screens */

    const scrollToActiveElement = () => {
        const itemRef = document.getElementById("selected-index-item-" + activeTab);
        if (containerRef.current && itemRef) {
            if (document.body.clientWidth < 767) {
                itemRef.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }
    };

    const handleScrollSpy = () => {
        const scrollMargin = scrollSpace ? scrollSpace + 66 : 80 ;// adjust to your fixed nav height
    
        for (let item of items) {
            const section = document.getElementById(item.key);
            if (section) {
                const rect = section.getBoundingClientRect();
                if (rect.top <= scrollMargin && rect.bottom > scrollMargin) {
                    if (activeTab !== item.key) {
                        setTab(item.key);
                        onTabChange && onTabChange(item.key);
                    }
                    return; // found the current section
                }
            }
        }
    };

    const scrollSpyRef = useRef(true);

const disableSpyTemporarily = () => {
    scrollSpyRef.current = false;
    setTimeout(() => {
        scrollSpyRef.current = true;
    }, 800); // allow scrollSpy back after smooth scroll finishes
};
    
    

    return (
        <div className={`dashboard-filter-left inner-navigation ${cssClasses}`} ref={containerRef}>
            {items.map((item) => (
                <span
                    key={item.key}
                    id={`selected-index-item-${item.key}`}
                    className={activeTab === item.key ? "active" : ""}
                    onClick={() => {
                        setTab(item.key);
                        onTabChange && onTabChange(item.key);
                    
                        const section = document.getElementById(item.key);
if (section) {
    const yOffset = section.getBoundingClientRect().top + window.scrollY - (scrollSpace ? scrollSpace + 66 : 80);
    window.scrollTo({
        top: yOffset,
        behavior: "smooth",
    });
    disableSpyTemporarily();
}
                    }}
                    
                >
                    {type === "tab" ? (
                        <a>
                            {item.icon}
                            {item.label}
                            {!item.isLoading ? (
                                item.count !== undefined && item.count !== null ? (
                                    <em className="tests-counter">({item.count})</em>
                                ) : null
                            ) : (
                                <Skeleton
                                    width={40}
                                    height={18}
                                    style={{
                                        borderRadius: "5px",
                                        marginLeft: "0px",
                                        top: "1px",
                                        right: "-10px",
                                        padding: "0px",
                                        lineHeight: "1",
                                    }}
                                />
                            )}
                        </a>
                    ) : (
                        <Link to={item.link}>
                            {item.icon} {item.label}
                            {!item.isLoading ? (
                                item.count !== undefined && item.count !== null ? (
                                    <em className="tests-counter">({item.count})</em>
                                ) : null
                            ) : (
                                <Skeleton
                                    width={40}
                                    height={18}
                                    style={{
                                        borderRadius: "5px",
                                        marginLeft: "0px",
                                        top: "1px",
                                        right: "-10px",
                                        padding: "0px",
                                        lineHeight: "1",
                                    }}
                                />
                            )}
                        </Link>
                    )}
                </span>
            ))}
        </div>
    );
};

export default InnerNavigationTab;
